export var MoneyfarmThemeDark = {
  id: 'mf-dark',
  palette: {
    white: {
      main: '#ffffff'
    }
  },
  tokens: {
    space: {
      primary: {
        regular: '#010101'
      },
      secondary: {
        regular: '#171717',
        gradient100: '#171717',
        gradient0: '#010101'
      },
      tertiary: {
        regular: '#192434',
        gradient100: '#192434',
        gradient0: '#010101'
      },
      reversed: {
        regular: '#F7F4EF',
        gradient100: '#F7F4EF',
        gradient0: '#FFFFFF'
      },
      surface: {
        regular: '#1C1C1E'
      },
      overlay: {
        regular: '#363636'
      },
      onOverlay: {
        regular: '#FFFFFF'
      }
    },
    accent: {
      token: {
        primary: {
          strong: '#A90E2D',
          regular: '#D93657',
          light: '#7D2C3C'
        },
        secondary: {
          strong: '#C2D5F5',
          regular: '#FFFFFF',
          light: '#697077'
        }
      },
      onToken: {
        primary: {
          strong: '#FFFFFF',
          regular: '#FFFFFF',
          light: '#FFFFFF'
        },
        secondary: {
          strong: '#000000',
          regular: '#121619',
          light: '#343A3E'
        }
      },
      base: {
        primary: {
          strong: '#C2D5F5',
          regular: '#FFFFFF',
          light: '#697077'
        },
        secondary: {
          strong: '#C2D5F5',
          regular: '#FFFFFF',
          light: '#697077'
        }
      }
    },
    interface: {
      shadow: {
        strong: '#000000',
        regular: '#000000',
        light: '#000000'
      },
      neutral: {
        strong: '#C1C7CD',
        regular: '#697077',
        light: '#313135',
        lightest: '#121619'
      },
      feedback: {
        negative: {
          strong: '#FCBEBE',
          regular: '#FA6161',
          light: '#D14747',
          lightest: '#A94A4A'
        },
        positive: {
          strong: '#BDF1C0',
          regular: '#45C14D',
          light: '#4CA752',
          lightest: '#3A7D3F'
        },
        warning: {
          strong: '#FBF0D3',
          regular: '#FFBC2E',
          light: '#EDAE0C',
          lightest: '#B88A45'
        },
        info: {
          strong: '#B7DCF3',
          regular: '#40ADF0',
          light: '#2290D4',
          lightest: '#2A6285'
        },
        tip: {
          strong: '#EEE7DC',
          regular: '#DFD0BA',
          light: '#AC987A',
          lightest: '#3D352B'
        }
      },
      onFeedback: {
        strong: '#121619',
        regular: '#121619',
        light: '#FFFFFF',
        lightest: '#FFFFFF'
      }
    },
    feature: {
      primary: {
        strong: '#007B7B',
        regular: '#0B9F9F',
        light: '#14BCBC',
        lightest: '#C4FFFF'
      },
      secondary: {
        strong: '#384F74',
        regular: '#5273A6',
        light: '#7C9CD2',
        lightest: '#F3F8FF'
      },
      cash: {
        strong: '#FBF0D3',
        regular: '#FFBC2E',
        light: '#EDAE0C',
        lightest: '#B88A45'
      },
      esg: {
        strong: '#EFFFF6',
        regular: '#7DC69F',
        light: '#5F9B79'
      },
      thematics: {
        strong: '#EEE7DC',
        regular: '#DFD0BA',
        light: '#AC987A',
        lightest: '#3D352B'
      }
    },
    chart: {
      primary: {
        main: '#ABC6F5',
        child1: '#384F74',
        child2: '#5273A6'
      },
      secondary: {
        main: '#FFC1CD',
        child1: '#F3758D',
        child2: '#FD8FA4'
      },
      tertiary: {
        main: '#DFD0BA',
        child1: '#AC987A',
        child2: '#CCB99D'
      },
      stacked: {
        primary: '#5273a6',
        secondary: '#abc6f5',
        tertiary: '#d25cb8',
        fourth: '#f1b3e3',
        fifth: '#ac987a',
        sixth: '#dfd0ba',
        seventh: '#5f9b79',
        eighth: '#93e3b5',
        ninth: '#ffe790',
        tenth: '#FFC2CF',
        eleventh: '#BFB1BC',
        twelfth: '#E7E7E7'
      }
    },
    allocation: {
      bond: {
        main: '#14BCBC',
        child01: '#0B9F9F',
        child02: '#14BCBC',
        child03: '#3BE1E1',
        child04: '#53F9F9',
        child05: '#89FFFF'
      },
      equity: {
        main: '#D25CB8',
        child01: '#D25CB8',
        child02: '#E388CF'
      },
      other: {
        main: '#FFDC68',
        child01: '#F5CA2E',
        child02: '#FFDC68'
      }
    },
    text: {
      title: {
        regular: '#FFFFFF',
        light: '#C1C7CD',
        lighter: '#697077',
        reversed: '#343A3E'
      },
      paragraph: {
        regular: '#FFFFFF',
        light: '#C1C7CD',
        lighter: '#697077',
        reversed: '#343A3E'
      },
      label: {
        regular: '#FFFFFF',
        light: '#C1C7CD',
        lighter: '#697077',
        reversed: '#343A3E',
        negative: '#FA6161',
        positive: '#45C14D',
        warning: '#FFBC2E',
        info: '#40ADF0',
        primary: '#FC6481',
        secondary: '#ABC6F5',
        tertiary: '#DFD0BA'
      }
    },
    spacing: {
      '2xs': '4px',
      xs: '8px',
      sm: '12px',
      md: '16px',
      lg: '24px',
      xl: '32px',
      '2xl': '40px',
      '3xl': '48px',
      '4xl': '64px',
      '5xl': '80px'
    }
  },
  typography: {
    font: {
      sizes: {
        small: 13,
        normal: 16,
        smedium: 18,
        medium: 21,
        big: 24,
        bigger: 38
      },
      weight: {
        normal: 400,
        semibold: 600
      },
      family: {
        title: 'Montserrat, "Open Sans", Helvetica, Arial;',
        text: '"Open Sans", Helvetica, Arial;'
      },
      style: ['normal']
    }
  }
};